(function () {

	if (!String.prototype.startsWith) {
		String.prototype.startsWith = function (searchString, position) {
			position = position || 0;
			return this.indexOf(searchString, position) === position;
		};
	}

	//Anchor Links	
	var messageEditMode = "Anchor links are only displayed in View mode. Please, preview or publish the page to show them.";
	var messageNoH3 = "No anchor links found";

	var anchorContainers = document.getElementsByClassName("anchor-links-wrap");

	if (anchorContainers.length > 0) {
		for (var i = 0, j = anchorContainers.length; i < j; i++) {
			var hTagsName = anchorContainers[i].attributes.getNamedItem("data-headerType").value;

			if (hTagsName !== null && hTagsName !== "") {
				 
				var elements = document.getElementsByTagName(hTagsName);

				var isEditMode = anchorContainers[i].attributes.getNamedItem("data-pageeditor") != null
					? "true" === anchorContainers[i].attributes.getNamedItem("data-pageeditor").value.toLowerCase()
					: false;
				isEditMode = false;
				if (!isEditMode) {
					var list = document.createElement("ul");
					list.setAttribute("class", "anchor-links");

					for (var k = 0, l = elements.length; k < l; k++) {
						var text = elements[k].innerText;
						if (!text.startsWith("{") &&
							elements[k].className.indexOf("exclude-navigation") < 0 &&
							text.trim().length > 0 &&
							!$(elements[k]).parent().hasClass('slick-slide')) {
							var element = getListElement(text, elements[k]);
							list.appendChild(element);
						}
					}

					var title = document.createElement("h2");
					var titleText = anchorContainers[i].attributes.getNamedItem("data-title").value;

					if (titleText == null || titleText == ""
					) titleText = "On this page"; //default fallback original value
					title.innerText = titleText;

					anchorContainers[i].appendChild(title);
					anchorContainers[i].appendChild(list);
				} else {
					var message = document.createElement("h4");
					message.innerText = elements.length > 0 ? messageEditMode : messageNoH3;
					anchorContainers[i].appendChild(message);
				}
			}
		}
	}

	function getListElement(text, linkedElement) {
		var element = document.createElement("li");
		element.setAttribute("class", "anchor-links-item");
		var link = document.createElement("a");
		link.setAttribute("href", "#");
		link.setAttribute("class", "anchor-links-link");
		link.innerText = text;
		link.addEventListener("click", function (event) {
			event.preventDefault();
			
			$('html, body').animate({
				scrollTop: $(linkedElement).offset().top - 100
			}, 500);
			// set focus
			$(linkedElement).attr('tabindex', '-1');
			setTimeout(function () {
				$(linkedElement).trigger('focus');
			}, 500);
		});

		element.appendChild(link);
		return element;
	};

})();